import { get } from '@antv/util';
import { Tooltip, TooltipMapping } from '../types/tooltip';

/**
 * è·å¾ tooltip çæ å°ä¿¡æ¯
 * @param tooltip
 * @param defaultFields
 */
export function getTooltipMapping(tooltip: Tooltip, defaultFields: string[]): TooltipMapping {
  if (tooltip === false) {
    return {
      fields: false, // å³é­ tooltip
    };
  }

  let fields = get(tooltip, 'fields');
  const formatter = get(tooltip, 'formatter');

  if (formatter && !fields) {
    fields = defaultFields;
  }

  return {
    fields,
    formatter,
  };
}
